

export const datetimestring = ()=>{
    var currentDate = new Date();
    var isoString = currentDate.toISOString();
    var stringWithoutSpaces = isoString.replace(/\s+/g, '').split(":").join("");
    return stringWithoutSpaces
}